import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'

import muteIcon from 'assets/mute.svg'
import unmuteIcon from 'assets/unmute.svg'
import { ImageButton } from '../../ImageButton'
import { addFeedContext } from '../context'

interface Props {
  className?: string
}

export const MuteButton: FC<Props> = flowMax(
  addDisplayName('MuteButton'),
  addFeedContext,
  addProps(({ isMuted }) => ({
    image: isMuted ? muteIcon : unmuteIcon,
  })),
  ({ image, toggleMuted, className }) => (
    <ImageButton
      image={image}
      width={48}
      height={48}
      onClick={toggleMuted}
      className={className}
    />
  )
)
